import React from "react";

// Deterministic gradient avatar from an address + a 5x5 identicon pattern.
function hashStr(s) {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h << 5) - h + s.charCodeAt(i);
  return Math.abs(h);
}

export default function Avatar({ address = "", id, size = 56 }) {
  const seed = hashStr(address || String(id) || "nexaura");
  const hue1 = seed % 360;
  const hue2 = (hue1 + 60) % 360;

  // 5x5 mirrored identicon
  const cells = [];
  const cell = size / 6;
  const pad = cell / 2;
  for (let y = 0; y < 5; y++) {
    for (let x = 0; x < 3; x++) {
      const on = (hashStr(`${seed}-${x}-${y}`) % 10) > 4;
      if (!on) continue;
      const px = pad + x * cell;
      const mx = pad + (4 - x) * cell;
      cells.push(<rect key={`${x}-${y}-a`} x={px} y={pad + y * cell} width={cell} height={cell} rx="1.5" />);
      if (x < 2) cells.push(<rect key={`${x}-${y}-b`} x={mx} y={pad + y * cell} width={cell} height={cell} rx="1.5" />);
    }
  }

  return (
    <div
      className="avatar-ring"
      style={{
        width: size + 8,
        height: size + 8,
        background: `conic-gradient(from 0deg, hsl(${hue1} 90% 60%), hsl(${hue2} 90% 60%), hsl(${hue1} 90% 60%))`,
      }}
    >
      <div className="avatar-inner" style={{ width: size, height: size }}>
        <svg width={size} height={size} style={{ opacity: 0.92 }}>
          <rect width={size} height={size} fill={`hsl(${hue1} 40% 16%)`} rx="14" />
          <g fill={`hsl(${hue2} 90% 65%)`}>{cells}</g>
        </svg>
      </div>
    </div>
  );
}
